// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"443":"about","809":"transfer"}[chunkId] + "-legacy." + {"443":"34d298fe","809":"ee2b96a6"}[chunkId] + ".js";
};